<template>
    <CustomHeader :text="$t('activityName.game_benefit')" :show-history="true" @openHistoryPopup="openHistoryPopup" />
    <div class="container">
        <van-row>
            <van-col :span="24">
                <img class="fundBannerImage" :src="dataSet.bannerIcon" alt="">
            </van-col>
        </van-row>
        <CashbackNotice :content="dataSet.activityIntro" />

        <div>
            <CashBackCard :title="$t('common.bets')" :create-date="dataSet.todayBetDetails?.createTime"
                :day="dataSet.todayBetDetails?.day" :available-value="dataSet.todayBetDetails?.availableAmount"
                :showClickButton="dataSet.todayBetDetails?.availableAmount > 0" :given-value="dataSet.todayBetDetails?.givenAmount"
                @get-claim="getClaim"
                :dayList="dataSet.futureRewards.length <= 0 ? getDefaultRewards(dataSet.dayCount) : dataSet.futureRewards" />
        </div>

        <CashbackWeekDetails :bet-list="dataSet.weeklyRewardList" :title="$t('activity.lossTotal')" type="LOSS"
            :cashback-total="dataSet.cashbackTotal" :istoday-claimed="dataSet.todayBetDetails?.availableAmount > 0" />

        <CashbackHistoryPopup ref="histryPopupRef" @getHistoryList="getHistoryList" :list="dataSet.historyList"
            @updateHistoryList="getNextPageRewardData" :showIcon="dataSet.total > dataSet.pageSize * dataSet.pageNum"
            :title="$t('activity.lossTotal')" @resetHistoryData="resetHistoryData" />
    </div>
</template>

<script setup lang="ts">
import { getDefaultRewards} from '@/utils/commonFunction';
import { ref } from 'vue'; 
import CashBackCard from './components/cashBackCard.vue';
import CashbackHistoryPopup from './components/cashbackHistoryPopup.vue';
import CashbackNotice from './components/cashbackNotice.vue';
import CashbackWeekDetails from './components/cashbackWeekDetails.vue';
import CustomHeader from '../components/common/customHeader.vue';
import { LossReliefData } from '@/view/lossReliefFunds/supportScript';

const histryPopupRef = ref()

const props = defineProps<{
    dataSet: LossReliefData
}>()

const emits = defineEmits(['getNextPageRewardData','getHistoryList', 'resetHistoryData', 'getClaim'])


const getNextPageRewardData = () => {
    emits('getNextPageRewardData')
}

const getHistoryList = () => {
    emits('getHistoryList')
}

const openHistoryPopup = (data: any) => {
    histryPopupRef.value.open(data)
}

const resetHistoryData = () => {
    emits('resetHistoryData')
}

const getClaim = () => {
    emits('getClaim')
}
</script>
<style scoped>
.container {
    padding: 50px 0;
    background: linear-gradient(180deg, #08040d7c 0%, #08040d 50%, #08040d00 100%);

}

.fundBannerImage {
    width: 100%;
}

.infoImage {
    position: relative;
}

.infoText {
    position: absolute;
    display: flex;
    top: 0;
    left: 25px;
    right: 25px;
    height: 70px;
    align-items: center;
    /* text-align: center; */
    color: #FFEE00;
}

.content {
    color: #fff;
    padding: 15px;
}

.image-wrapper {
    position: relative;
    display: inline-block;
}

.arrowDown {
    display: flex;
    justify-content: center;

}

.arrowDown img {
    width: 25px;
    transform: rotate(-90deg);
    padding: 10px;
}

.bottom_text {
    padding: 25px;
}

.line1 {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.line2 {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.title {
    color: rgba(255, 255, 255, 0.85);
    font-size: 15px;
    display: flex;
    justify-content: center;
}

.line_text {
    color: rgba(255, 255, 255, 0.45);
    font-size: 14px;
    padding: 10px;
    line-height: 20px;
}
</style>